export const TOKEN_HEADER = 'authorization';
export const TOKEN_KEY = 'token'; // localstorage key
export const REFRESH_HEADER = 'refresh-authorization';
export const REFRESH_KEY = 'refresh_token'; // localstorage key
